import { FindOptionTitle } from '@smart-builder/util';
import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  CRUserBody,
  CRUserBodyAPI,
  CRUserKey,
  CRUserSummary,
  CRUserSummaryAPI,
  UsersActions,
  UsersState,
} from './types';

type AnyUser = CRUserKey | CRUserBody | undefined;

function getEndpointUser(key: AnyUser): string {
  return key ? `/users/${key.userId}/` : '/users/';
}

function sameUser(a: AnyUser, b: AnyUser): boolean {
  return a?.userId === b?.userId;
}

function mergeUser(last: CRUserBody, current: CRUserBody): CRUserBody {
  // no merging with previous body necessary, just keep latest
  return current;
}

function parseUserBody(body: CRUserBodyAPI): CRUserBody {
  return body;
}

function parseUserSummary(summary: CRUserSummaryAPI): CRUserSummary {
  return summary;
}

function mergeSummaryBody(
  summary?: CRUserSummary,
  body?: CRUserBody,
): CRUserSummary {
  const merge = mergeSummaryBodyField(summary, body);
  return {
    ...summary,
    userId: merge('userId'),
    loginWindows: merge('loginWindows'),
    loginWeb: merge('loginWeb'),
    userName: merge('userName'),
    title: merge('title'),
    email: merge('email'),
    phone: merge('phone'),
    quotedBy: merge('quotedBy'),
    branchName: body ? FindOptionTitle(body.branchNum) : summary?.branchName,
    // TODO branchName - lookup from options in body
  };
}

const usersStateSelector = (state: any): UsersState => state.users;

const { actions, reducer, watches, rawActions } = createMainResourceREST(
  'user',
  getEndpointUser,
  usersStateSelector,
  sameUser,
  parseUserBody,
  parseUserSummary,
  mergeUser,
  mergeSummaryBody,
);

const usersActions: UsersActions = actions;
export {
  usersActions,
  reducer as usersReducer,
  watches as usersWatches,
  usersStateSelector,
  rawActions as usersRawActions,
};

export * from './types';
